// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".delete-additional-payment[data-v-39104518] {\n  position: absolute;\n  right: 33px;\n}\n@media only screen and (max-width: 768px) {\n.delete-additional-payment[data-v-39104518] {\n    position: relative;\n    right: 0px;\n    margin-left: 37px;\n    margin-top: 10px;\n}\n}", ""]);
// Exports
module.exports = exports;
